import {UserGender} from "@ok/web/models/user/UserGender";
import {IAvatarSize} from "@ok/web/components/base/Avatars/AvatarCore/AvatarCore";
import {IGroupAvatarType} from "@ok/web/components/base/Avatars/GroupAvatar/GroupAvatar";

export enum StubType {
    USER,
    GROUP
}

export type BuildStubURLOptions = {
    size: IAvatarSize,
    type?: IGroupAvatarType,
    gender?: UserGender | keyof typeof UserGender
}

const STUB_SIZES = [50, 64, 128, 190, 370];
const getStubSize = (avatarSize: IAvatarSize) => {
    for (const stubSize of STUB_SIZES) {
        const size = +avatarSize;
        if (size <= stubSize) {
            return stubSize;
        }
    }

    return STUB_SIZES[STUB_SIZES.length - 1];
};

export function buildStubURL(stubType: StubType, options: BuildStubURLOptions) {
    const {size, type, gender} = options;

    if (stubType === StubType.USER) {
        const stubGender = gender === UserGender[UserGender.MALE] ? "male" : "female";

        return `/mres/img/stb3/${stubGender}_${getStubSize(size)}@2x.png`;
    }

    if (stubType === StubType.GROUP) {
        const condition = `${size}_${type}`;
        switch (condition) {
            case "32_Event":
                return `/mres/img/stb2/group_event_64.png`;
            case "32_":
                return `/mres/img/stb2/group_ava_${size}.png`;
            case "64_Event":
                return `/mres/img/stb2/group_event_${size}.png`;
            case "64_":
                return `/mres/img/stb2/group_${size}.png`;
            default:
                return `/mres/img/stb2/group_ava_64.png`;
        }
    }

    throw new Error(`Error! StubType "${stubType}" not found`);
}
